export const validation = {
  supTitleMaxChar: 100,
  headingMaxChar: 60,
  paragraphMaxChar: 200,
  headerSocials: {
    min: 0,
    max: 6
  }
}
